import React from 'react'

export const ExportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38948 8.98403H6.45648C4.42148 8.98403 2.77148 10.634 2.77148 12.669V17.544C2.77148 19.578 4.42148 21.228 6.45648 21.228H17.5865C19.6215 21.228 21.2715 19.578 21.2715 17.544V12.659C21.2715 10.63 19.6265 8.98403 17.5975 8.98403L16.6545 8.98403"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0215 2.19051V14.2315"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.1062 5.11884L12.0212 2.19084L14.9372 5.11884"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
